import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { DestroyBase } from '../../../../components/common/ng-destroy-base';
import { PixIntegrationService } from '../../../../modules/project-valuation/services/pix-integration-service.service';
import { CompsIntegrationEnum } from '../models/enums/comps-integration-enum';

/**
 * Properties Comparables Sidebar
 */
@Component({
  selector: 'properties-comparables-delete-sidebar',
  templateUrl: './properties-comparables-delete-sidebar.component.html',
  styleUrls: ['./properties-comparables-delete-sidebar.component.scss', '../../../../modules/project-valuation/import/import-wizard/import-wizard.component.css', '../../../../modules/app-dataverse/components/v2/fields-overview/fields-overview.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class PropertiesComparablesDeleteSidebarComponent extends DestroyBase {
  /**
   * The subjectProperty
   */
  @Input() selectedProperty: any;

  /**
   * Retrieves argus sync option enum
   */
  get CompsIntegrationEnum() {
    return CompsIntegrationEnum;
  }

  /**
   * Has sales comparables?
   */
  @Input() hasSalesComparables: any;

  /**
   * Has lease comparables?
   */
  @Input() hasLeaseComparables: any;

  /**
   * Has I&E comparables?
   */
  @Input() hasIEComparables: any;

  /**
 * The PixIntegrationService
 */
  private _pixIntegrationService: PixIntegrationService;

  /**
   * Colapse pane event
   */
  @Output() closePane: EventEmitter<any> = new EventEmitter();

  /**
   * Disable delete button
   */
  @Output() disableDelete: EventEmitter<any> = new EventEmitter();

  /**
   * Should the dialog be closed?
   */
  shouldClose = false;

  /**
  Type of connected Comps that should be deleted
  */
  typeOfDeletedComps: CompsIntegrationEnum = CompsIntegrationEnum.None;

  /**
   * Close was clicked
   */
  onCloseClicked() {
    this.shouldClose = true;
    setTimeout(() => {
      this.closePane.emit();
    }, 500);//let animation finish
  }

  /**
   * Delete clicked
   */
  onDelete() {
    this._pixIntegrationService.deleteConnectedComps(this.selectedProperty?.subjectPropertyId, this.typeOfDeletedComps)
      .subscribe(deleteResult => {
        if (!deleteResult?.success) {
          alert(deleteResult.message);
        }
        else if (deleteResult?.success) {
          if (this.typeOfDeletedComps == this.compsIntegrationType.Lease) {
            this.hasLeaseComparables = false;
            this.selectedProperty.hasLeaseComparables = false;
          }
          else if (this.typeOfDeletedComps == this.compsIntegrationType.Sale) {
            this.hasSalesComparables = false;
            this.selectedProperty.hasSalesComparables = false;
          }
          else if (this.typeOfDeletedComps == this.compsIntegrationType.IE) {
            this.hasIEComparables = false;
            this.selectedProperty.hasIEComparables = false;
          }
          else {
            this.hasSalesComparables = false;
            this.hasLeaseComparables = false;
            this.hasIEComparables = false;
            this.selectedProperty.hasLeaseComparables = false;
            this.selectedProperty.hasSalesComparables = false;
            this.selectedProperty.hasIEComparables = false;
          }

          if (!this.hasSalesComparables && !this.hasLeaseComparables && !this.hasIEComparables) {
            this.disableDelete.emit(true);
          }

          // Close delete pane
          setTimeout(() => {
            this.closePane.emit();
          }, 500);//let animation finish

          alert("Connected comps deleted successfully!");

        }
      });
  }

  /**
   * Pix sale comps response
   */
  pixCompsSalesResponse: any[] = [];

  /**
   * Pix lease comps response
   */
  pixCompsLeaseResponse: any[] = [];

  /**
   * Get Comps Integration Enum Type
   */
  public get compsIntegrationType(): typeof CompsIntegrationEnum {
    return CompsIntegrationEnum;
  }

  /**
   * Constructor
   * @param _pixIntegrationService PixIntegrationService
   */
  constructor(pixIntegrationService: PixIntegrationService) {
    super();
    this._pixIntegrationService = pixIntegrationService;
  }

  /**
 * On selected deleteComps change action
 * @param deleteComps Selected property
 */
  onSelectedCompsChange(compsIntegrationEnum: CompsIntegrationEnum) {
    this.typeOfDeletedComps = compsIntegrationEnum;
  }
}
